import { Component, Watch, Vue } from 'vue-property-decorator';
import Sidebar from '@/components/Sidebar/Sidebar.vue';

@Component({
    components: {
        Sidebar
    }
})
export default class MasterSetting extends Vue {
}